var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('app-vue-editor',{attrs:{"editorToolbar":_vm.customToolbar},on:{"input":function($event){return _vm.$v.commitments.$touch()}},model:{value:(_vm.commitments),callback:function ($$v) {_vm.commitments=$$v},expression:"commitments"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }